import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState,ListMutations, ListStateItem, ListModuleItem} from '@/store/shared'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

import Factory from './entity'
import Tree from "@/store/shared/entity/tree";

interface FactoryState extends ListStateItem<Factory>{
    editFactory:Factory,
    factoryList: Array<any>;
}

class FactoryModule extends ListModuleItem<FactoryState,any,Factory>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editFactory:new Factory(),
        factoryList: new Array<any>(),
    }
    actions={
        async getAll(context:ActionContext<FactoryState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('services/app/Factory/GetAll',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<Factory>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<FactoryState,any>,payload:any){
            await $http.post('services/app/Factory/Create',payload.data);
        },
        async update(context:ActionContext<FactoryState,any>,payload:any){
            await $http.put('services/app/Factory/Update',payload.data);
        },
        async delete(context:ActionContext<FactoryState,any>,payload:any){
            await $http.delete('services/app/Factory/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<FactoryState,any>,payload:any){
            let reponse=await $http.get('services/app/Factory/Get?Id='+payload.id);
            return reponse.data.result as Factory;
        },
        async getFactoryList(context:ActionContext<FactoryState,any>){
            
            let reponse = await $http.get('services/app/Factory/GetFactoryOption');
            context.state.factoryList = reponse.data.result;
            
        },
        async getFactorySelectOptions(context:ActionContext<FactoryState,any>){
            let reponse = await $http.get('services/app/Factory/GetFactorySelectOptions');
            return reponse.data.result;
        },
    };
    overrideMutations={
        edit(state:FactoryState,factory:Factory){
            state.editFactory=factory;
        }
    }
}
const factoryModule=new FactoryModule();
export default factoryModule;